import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const PartnerOnboardingLanding = () =>
  import('@/pages/partner-administration/partner-onboarding/landing/PartnerOnboardingLanding.vue');
const PartnerOnboardingApiPartner = () =>
  import('@/pages/partner-administration/partner-onboarding/api-partner/PartnerOnboardingApiPartner.vue');
const PartnerOnboardingFleetApis = () =>
  import('@/pages/partner-administration/partner-onboarding/fleet-apis/PartnerOnboardingFleetApis.vue');
const PartnerOnboardingPortalRecordOnly = () =>
  import('@/pages/partner-administration/partner-onboarding/portal-record-only/PartnerOnboardingPortalRecordOnly.vue');
const PartnerOnboardingManualHandoff = () =>
  import('@/pages/partner-administration/partner-onboarding/manual-handoff/PartnerOnboardingManualHandoff.vue');
const PartnerOnboardingJourneyList = () =>
  import('@/pages/partner-administration/partner-onboarding/journey-list/PartnerOnboardingJourneyList.vue');
const PartnerOnboardingJourneyDetail = () =>
  import('@/pages/partner-administration/partner-onboarding/journey-detail/PartnerOnboardingJourneyDetail.vue');
const PartnerOnboardingFlowFinder = () =>
  import('@/pages/partner-administration/partner-onboarding/flow-finder/PartnerOnboardingFlowFinder.vue');
const PartnerChecklistList = () =>
  import('@/pages/partner-administration/partner-onboarding/checklists/PartnerChecklistList.vue');
const PartnerChecklistDetail = () =>
  import('@/pages/partner-administration/partner-onboarding/checklists/PartnerChecklistDetail.vue');

export const partnerOnboardingRoutes: AppRouteRecordRaw[] = [
  {
    path: '/partner-administration/partner-onboarding',
    component: Body,
    meta: {
      breadcrumb: 'Partner Onboarding',
    },
    children: [
      {
        path: '',
        name: 'partnerOnboardingLanding',
        component: PartnerOnboardingLanding,
        meta: {
          title: 'Onboard a New Partner | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Onboard a New Partner',
        },
      },
      {
        path: 'flow-finder',
        name: 'partnerOnboardingFlowFinder',
        component: PartnerOnboardingFlowFinder,
        meta: {
          title: 'Flow Finder Decision Assistant | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Flow Finder',
        },
      },
      {
        path: 'api-partner',
        name: 'partnerOnboardingApiPartner',
        component: PartnerOnboardingApiPartner,
        meta: {
          title: 'Onboard rydpay API Partner | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'rydpay API Partner',
        },
      },
      {
        path: 'fleet-apis',
        name: 'partnerOnboardingFleetApis',
        component: PartnerOnboardingFleetApis,
        meta: {
          title: 'Onboard Fleet API Partner | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Fleet API Partner',
        },
      },
      {
        path: 'portal-record-only/:flowType',
        name: 'partnerOnboardingPortalRecordOnly',
        component: PartnerOnboardingPortalRecordOnly,
        meta: {
          title: 'Onboard Partner | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Portal Record Onboarding',
        },
      },
      {
        path: 'manual-handoff/:flowType',
        name: 'partnerOnboardingManualHandoff',
        component: PartnerOnboardingManualHandoff,
        meta: {
          title: 'Manual Partner Handoff | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Manual Handoff',
        },
      },
      {
        path: 'journeys',
        name: 'partnerOnboardingJourneyList',
        component: PartnerOnboardingJourneyList,
        meta: {
          title: 'Onboarding Journeys | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Onboarding Journeys',
        },
      },
      {
        path: 'journeys/:journeyId',
        name: 'partnerOnboardingJourneyDetail',
        component: PartnerOnboardingJourneyDetail,
        meta: {
          title: 'Onboarding Journey | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Journey Detail',
        },
      },
      {
        path: 'checklists',
        name: 'partnerOnboardingChecklistList',
        component: PartnerChecklistList,
        meta: {
          title: 'Partner Checklists | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Partner Checklists',
        },
      },
      {
        path: 'checklists/:checklistId',
        name: 'partnerOnboardingChecklistDetail',
        component: PartnerChecklistDetail,
        meta: {
          title: 'Partner Checklist | ryd Portal',
          requiresAuth: true,
          requiredRoles: ['partnerAdmin'],
          breadcrumb: 'Checklist Detail',
        },
      },
    ],
  },
];
